import functions from '@/services/functions';

export default {
  data() {
    return {
      acl: functions,
    };
  },
};
